import type { ContentItem } from '@/types/content';

export const blacklistItems: ContentItem[] = [
  {
    id: 'bl-1001',
    type: 'blacklist',
    title: '星轨联赛 10月10日 今日黑榜',
    summary:
      '星轨联赛第三赛段收官战，林夜在关键团战中连续两次技能空放，节奏控制评分跌至赛季新低，排名单日下滑四个位次，位列今日黑榜首位。',
    event: '星轨联赛',
    category: '竞技排名',
    date: '2026-10-10 09:20',
    author: '赛事数据中心',
    source: '51每日大赛',
    tags: ['星轨联赛', '今日黑榜', '团战失误'],
    cover:
      'https://readdy.ai/api/search-image?query=Professional%20esports%20arena%20stage%20with%20dramatic%20navy%20blue%20lighting%20and%20large%20scoreboard%20screens%2C%20audience%20silhouette%20in%20the%20background%2C%20cinematic%20sports%20broadcast%20atmosphere%20with%20orange%20accent%20lights%2C%20high%20detail%20editorial%20photography&width=800&height=450&seq=bl-1001-cover&orientation=landscape',
    player: '林夜',
    team: '晨曦战队',
    rank: 3,
    rankChange: -4,
    performanceIndex: 62,
    reason: '关键团战连续失误，资源控制与节奏带动效率下降，击杀参与率仅为 41%。',
    content: [
      '在今日进行的星轨联赛第三赛段收官战中，晨曦战队中单选手林夜表现低迷。首局比赛开始后，林夜在野区资源争夺中两次技能空放，直接导致战队丧失了前期的视野主动权。',
      '进入中后期团战，林夜的走位多次被对手预判，连续三次被先手控制秒杀，团队经济差一度被拉开至 8K。根据赛事数据中心统计，本场比赛林夜的击杀参与率仅为 41%，低于其赛季平均水平的 68%。',
      '赛后数据面板显示，林夜的综合表现指数从赛季平均的 82 下滑至 62，为近二十场比赛的最差表现。战队教练组在采访中表示，将针对选手的心态与决策进行专项复盘。',
    ],
    rankTable: [
      { rank: 1, player: '苏晨', team: '极光战队', change: 2, score: 91.2 },
      { rank: 2, player: '顾北', team: '黎明战队', change: 1, score: 88.6 },
      { rank: 3, player: '林夜', team: '晨曦战队', change: -4, score: 62.4 },
      { rank: 4, player: '江辞', team: '深渊战队', change: 0, score: 79.8 },
      { rank: 5, player: '沈墨', team: '雷霆战队', change: -1, score: 74.1 },
    ],
  },
  {
    id: 'bl-1002',
    type: 'blacklist',
    title: '极光杯 10月10日 今日黑榜',
    summary:
      '极光杯八强首日，主力打野苏晨前期反野连续被抓，野区经济落后，未能带动全队节奏，成为当日排名下滑幅度最大的选手。',
    event: '极光杯',
    category: '竞技排名',
    date: '2026-10-10 10:05',
    author: '赛事数据中心',
    source: '51每日大赛',
    tags: ['极光杯', '今日黑榜', '野区失误'],
    cover:
      'https://readdy.ai/api/search-image?query=Dark%20esports%20competition%20stage%20with%20deep%20blue%20haze%20and%20glowing%20screens%2C%20gaming%20keyboard%20and%20headset%20close%20up%20in%20foreground%2C%20moody%20cinematic%20lighting%20with%20warm%20orange%20rim%20light%2C%20high%20detail%20editorial%20photography&width=800&height=450&seq=bl-1002-cover&orientation=landscape',
    player: '苏晨',
    team: '极光战队',
    rank: 6,
    rankChange: -5,
    performanceIndex: 58,
    reason: '前期反野路线成功率极低，野区经济被压制，全场比赛仅完成 1 次有效游走支援。',
    content: [
      '极光杯八强首日的焦点战中，极光战队打野苏晨未能延续小组赛的出色状态。开局阶段，苏晨选择入侵对方野区，却连续两次被对手反蹲成功，前期经济落后超过一千。',
      '由于野区节奏被彻底压制，极光战队的双线发育均受到影响，全场比赛苏晨仅完成 1 次有效游走支援，控下的大龙与先锋数量为零。',
      '数据面板显示，苏晨本场表现指数为 58，是本赛季个人的最低值。评论席上多位分析人士指出，其反野路线过于固定，早已被对手研究透彻。',
    ],
    rankTable: [
      { rank: 1, player: '陆行舟', team: '暗夜战队', change: 3, score: 92.5 },
      { rank: 2, player: '顾北', team: '黎明战队', change: 0, score: 87.3 },
      { rank: 3, player: '江辞', team: '深渊战队', change: 2, score: 85.0 },
      { rank: 4, player: '林夜', team: '晨曦战队', change: -1, score: 70.4 },
      { rank: 5, player: '沈墨', team: '雷霆战队', change: 1, score: 76.2 },
      { rank: 6, player: '苏晨', team: '极光战队', change: -5, score: 58.1 },
    ],
  },
  {
    id: 'bl-1003',
    type: 'blacklist',
    title: '暗夜争霸赛 10月10日 今日黑榜',
    summary:
      '暗夜争霸赛主坦位选手陆行舟在防守端频繁失位，团战承伤转化率不足四成，扛不住关键伤害导致后排被瞬间击穿。',
    event: '暗夜争霸赛',
    category: '竞技排名',
    date: '2026-10-10 11:40',
    author: '赛事数据中心',
    source: '51每日大赛',
    tags: ['暗夜争霸赛', '今日黑榜', '承伤不足'],
    cover:
      'https://readdy.ai/api/search-image?query=Neon%20lit%20indoor%20esports%20arena%20with%20tiered%20seating%20and%20large%20broadcast%20screens%2C%20cool%20blue%20and%20orange%20stage%20lights%2C%20competitive%20gaming%20atmosphere%2C%20sleek%20modern%20architecture%2C%20high%20detail%20editorial%20photography&width=800&height=450&seq=bl-1003-cover&orientation=landscape',
    player: '陆行舟',
    team: '暗夜战队',
    rank: 8,
    rankChange: -3,
    performanceIndex: 55,
    reason: '防守端频繁失位，团战承伤转化率仅 38%，多次未能保护后排输出。',
    content: [
      '暗夜争霸赛小组赛第二轮，暗夜战队主坦陆行舟的发挥成为全队失利的缩影。在多次阵地战中，陆行舟的位置选择过于靠前，导致后排输出位暴露在对手的突进路线上。',
      '统计显示，陆行舟本场承伤转化率仅为 38%，远低于其赛季平均的 61%。关键的大龙争夺战中，其一次开团时机误判直接让对手完成反打。',
      '赛后数据团队评价，陆行舟需要在视野控制与开团时机的判断上做出调整，否则将持续影响战队的团战稳定性。',
    ],
    rankTable: [
      { rank: 1, player: '沈墨', team: '雷霆战队', change: 4, score: 90.1 },
      { rank: 2, player: '苏晨', team: '极光战队', change: -1, score: 84.7 },
      { rank: 3, player: '顾北', team: '黎明战队', change: 1, score: 82.9 },
      { rank: 4, player: '林夜', team: '晨曦战队', change: 2, score: 78.5 },
      { rank: 5, player: '江辞', team: '深渊战队', change: 0, score: 77.0 },
      { rank: 6, player: '贺川', team: '星海战队', change: -2, score: 71.3 },
      { rank: 7, player: '程野', team: '苍穹战队', change: 1, score: 68.8 },
      { rank: 8, player: '陆行舟', team: '暗夜战队', change: -3, score: 55.4 },
    ],
  },
  {
    id: 'bl-1004',
    type: 'blacklist',
    title: '雷霆竞技场 10月10日 今日黑榜',
    summary:
      '雷霆竞技场新赛制首秀，沈墨在限时推进模式下决策拖沓，团队资源利用率下降，成为当日失误统计最多的选手。',
    event: '雷霆竞技场',
    category: '竞技排名',
    date: '2026-10-10 13:15',
    author: '赛事数据中心',
    source: '51每日大赛',
    tags: ['雷霆竞技场', '今日黑榜', '决策拖沓'],
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20esports%20stadium%20with%20curved%20displays%20and%20spotlights%2C%20deep%20navy%20and%20orange%20color%20scheme%2C%20empty%20player%20desks%20with%20gaming%20chairs%2C%20dramatic%20cinematic%20atmosphere%2C%20high%20detail%20editorial%20photography&width=800&height=450&seq=bl-1004-cover&orientation=landscape',
    player: '沈墨',
    team: '雷霆战队',
    rank: 4,
    rankChange: -2,
    performanceIndex: 64,
    reason: '限时推进模式下决策拖沓，资源利用率下降，全场失误统计多达 9 次。',
    content: [
      '雷霆竞技场在新赛季调整了赛制，引入限时推进模式，对选手的决策速度提出了更高要求。首秀之战中，雷霆战队核心沈墨明显未能适应新节奏。',
      '在多轮资源争夺中，沈墨的决策平均耗时比对手多出 1.8 秒，直接导致团队错失多次推进窗口。全场失误统计多达 9 次，为当日所有选手之首。',
      '分析人士认为，新赛制强调快节奏与高执行力，沈墨需要尽快缩短决策链条，才能延续其在旧赛制中的统治力。',
    ],
    rankTable: [
      { rank: 1, player: '贺川', team: '星海战队', change: 3, score: 89.4 },
      { rank: 2, player: '程野', team: '苍穹战队', change: 1, score: 85.6 },
      { rank: 3, player: '江辞', team: '深渊战队', change: 0, score: 80.2 },
      { rank: 4, player: '沈墨', team: '雷霆战队', change: -2, score: 64.0 },
      { rank: 5, player: '陆行舟', team: '暗夜战队', change: -1, score: 69.5 },
    ],
  },
  {
    id: 'bl-1005',
    type: 'blacklist',
    title: '黎明锦标赛 10月10日 今日黑榜',
    summary:
      '黎明锦标赛半决赛，老将顾北体力分配失衡，决胜局手感急剧下滑，关键命中率跌至三成，无缘晋级决赛。',
    event: '黎明锦标赛',
    category: '竞技排名',
    date: '2026-10-10 15:30',
    author: '赛事数据中心',
    source: '51每日大赛',
    tags: ['黎明锦标赛', '今日黑榜', '体能下滑'],
    cover:
      'https://readdy.ai/api/search-image?query=Intense%20esports%20match%20scene%20with%20spotlight%20on%20a%20single%20gaming%20station%2C%20deep%20blue%20background%20with%20warm%20orange%20edge%20glow%2C%20dynamic%20competitive%20mood%2C%20cinematic%20lighting%2C%20high%20detail%20editorial%20photography&width=800&height=450&seq=bl-1005-cover&orientation=landscape',
    player: '顾北',
    team: '黎明战队',
    rank: 5,
    rankChange: -2,
    performanceIndex: 61,
    reason: '决胜局体力分配失衡，关键命中率跌至 30%，决胜阶段连续三轮未能得分。',
    content: [
      '黎明锦标赛半决赛打满五局，老将顾北在决胜局的表现出现明显波动。前四局中，顾北依旧展现了稳定的输出能力，但进入决胜局后手感急剧下滑。',
      '数据统计显示，顾北决胜局的关键命中率仅为 30%，并连续三轮在关键回合未能取得分数，最终战队以微弱分差惜败，无缘决赛。',
      '评论席普遍认为，密集赛程下的体力分配是顾北本次失利的关键因素，其赛季平均关键命中率高达 58%，落差十分明显。',
    ],
    rankTable: [
      { rank: 1, player: '林夜', team: '晨曦战队', change: 2, score: 90.8 },
      { rank: 2, player: '苏晨', team: '极光战队', change: 1, score: 86.1 },
      { rank: 3, player: '陆行舟', team: '暗夜战队', change: 0, score: 81.7 },
      { rank: 4, player: '贺川', team: '星海战队', change: -1, score: 76.9 },
      { rank: 5, player: '顾北', team: '黎明战队', change: -2, score: 61.2 },
    ],
  },
  {
    id: 'bl-1006',
    type: 'blacklist',
    title: '深渊王者赛 10月10日 今日黑榜',
    summary:
      '深渊王者赛冠军组对决，江辞沟通配合出现问题，团队协作评分大幅走低，多个关键信号被队友忽略。',
    event: '深渊王者赛',
    category: '竞技排名',
    date: '2026-10-10 17:10',
    author: '赛事数据中心',
    source: '51每日大赛',
    tags: ['深渊王者赛', '今日黑榜', '团队配合'],
    cover:
      'https://readdy.ai/api/search-image?query=Team%20of%20esports%20players%20seen%20from%20behind%20facing%20large%20glowing%20screens%2C%20deep%20blue%20ambient%20light%20with%20orange%20highlights%2C%20dark%20competitive%20arena%20atmosphere%2C%20cinematic%20depth%20of%20field%2C%20high%20detail%20editorial%20photography&width=800&height=450&seq=bl-1006-cover&orientation=landscape',
    player: '江辞',
    team: '深渊战队',
    rank: 7,
    rankChange: -4,
    performanceIndex: 57,
    reason: '团队沟通配合出现问题，协作评分下滑，多个关键信号被队友忽略。',
    content: [
      '深渊王者赛冠军组对决中，深渊战队指挥江辞与队友之间的配合出现明显脱节。多个关键时间点，江辞发出的进攻信号未能得到队友响应，导致团队阵型分散。',
      '从团队协作评分来看，深渊战队本场仅为 57 分，较其赛季平均的 79 分大幅走低。江辞个人的指挥准确率也下降了近二十个百分点。',
      '赛后江辞在采访中坦言，近期队伍在战术沟通上存在分歧，需要通过复盘重新统一思路，才能在接下来的淘汰赛中稳住阵脚。',
    ],
    rankTable: [
      { rank: 1, player: '程野', team: '苍穹战队', change: 2, score: 88.3 },
      { rank: 2, player: '贺川', team: '星海战队', change: 0, score: 84.9 },
      { rank: 3, player: '苏晨', team: '极光战队', change: 1, score: 82.0 },
      { rank: 4, player: '顾北', team: '黎明战队', change: -1, score: 75.6 },
      { rank: 5, player: '陆行舟', team: '暗夜战队', change: 1, score: 73.2 },
      { rank: 6, player: '沈墨', team: '雷霆战队', change: -2, score: 68.4 },
      { rank: 7, player: '江辞', team: '深渊战队', change: -4, score: 57.0 },
    ],
  },
];